<template>
  <section class="login-page wh100 mauto fixed left0 top0">

    <div>
      <figure class="logo mauto">
        <img class="w100" src="../assets/logo.svg" alt="logo">
      </figure>

      <!-- RESET PASS FORM -->

      <ValidationObserver v-slot="{ invalid }">

        <form v-if="isResetPass"
              @submit.prevent="submitNewPass"
              class="relative">

          <div>
            <validation-provider rules="required|password:@confirm"
                                 v-slot="{ errors }">
              <input type="text"
                     :class="{'invalid-input': errors[0]}"
                     v-model="new_pass"
                     autocomplete="198sd8as8d823121"
                     placeholder="parolă nouă">
            </validation-provider>
          </div>

          <div class="mtop20px">
            <validation-provider vid="confirm"
                                 name="confirm"
                                 rules="required"
                                 v-slot="{ errors }">
              <input type="text"
                     :class="{'invalid-input': errors[0]}"
                     autocomplete="asdasd090a9ds"
                     v-model="confirm"
                     placeholder="repeta parola">
            </validation-provider>
          </div>

          <button class="submit w100 block no-outline pointer"
                  :class="{'submit-active': !invalid}"
                  :disabled="invalid">salvează</button>

        </form>

        <form v-else
              @submit.prevent="submit"
              class="relative">

          <p v-if="resetEmailSent"
             class="reset-pass-text">
            Link-ul de resetare al parolei a fost trimis pe email.

            <button @click.stop="backToLogin">login</button>
          </p>

          <div v-else>
            <div>
              <validation-provider rules="required|email"
                                   v-slot="{ errors }">
                <input type="text"
                       :class="{'invalid-input': errors[0]}"
                       id="email"
                       v-model="email"
                       placeholder="email">
              </validation-provider>
            </div>

            <div class="mtop20px"
                 v-if="isPassField">

              <validation-provider
                rules="required"
                v-slot="{ errors }">
                <input :type="passView ? 'text' : 'password'"
                       id="password"
                       :class="{'invalid-input': errors[0]}"
                       v-model="password"
                       placeholder="parola">
                <i class="absolute pointer"
                   @click="passView = !passView">
                  <svg class="eye-icon-view-pass" v-if="passView" width="26px" height="23px" viewBox="0 0 26 23" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                    <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                      <g transform="translate(-485.000000, -235.000000)" fill="#ABABAB" fill-rule="nonzero">
                        <path d="M507.808036,235 L509.142857,236.334821 L504.964286,240.455357 C506.782747,241.654768 508.794632,243.589272 511,246.258929 L509.810267,247.535715 C509.612946,247.744643 509.44,247.925714 509.291429,248.078928 L509.026786,248.348214 C508.639879,248.735121 507.924112,249.38318 506.879464,250.292411 C505.834816,251.201641 504.935272,251.869045 504.180804,252.294643 C503.426336,252.72024 502.488101,253.126486 501.366071,253.513393 C500.244042,253.9003 499.122029,254.09375 498,254.09375 C496.065467,254.09375 494.285722,253.668159 492.660714,252.816964 L488.191964,257.285714 L486.857143,255.950893 L490.977679,251.830357 C489.816958,251.017853 487.824419,249.122039 485,246.142857 C487.476203,243.43451 489.700883,241.432298 491.674107,240.136161 C493.647331,238.840023 495.755941,238.191964 498,238.191964 C499.779771,238.191964 501.559515,238.6369 503.339286,239.526786 L507.808036,235 Z M502.294643,243.125 L499.392857,246.084821 C499.508929,246.123512 499.66369,246.142857 499.857143,246.142857 C500.24405,246.142857 500.63095,246.007442 501.017857,245.736607 L501.017857,245.736607 L501.017857,246.142857 C501.017857,246.994052 500.727681,247.719491 500.147321,248.319196 C499.566961,248.918902 498.851195,249.21875 498,249.21875 C497.458331,249.21875 496.99405,249.10268 496.607143,248.870536 L496.607143,248.870536 L494.982143,250.4375 C495.872028,251.095241 496.877971,251.424107 498,251.424107 C499.431555,251.424107 500.659965,250.901791 501.685268,249.857143 C502.710571,248.812495 503.223214,247.574412 503.223214,246.142857 C503.223214,245.059518 502.913694,244.053576 502.294643,243.125 L502.294643,243.125 Z M498,240.861607 C496.568445,240.861607 495.340035,241.383923 494.314732,242.428571 C493.289429,243.47322 492.776786,244.711302 492.776786,246.142857 C492.776786,247.187505 493.086306,248.174103 493.705357,249.102679 L495.272321,247.535714 C495.078868,247.187498 494.982143,246.723217 494.982143,246.142857 C494.982143,245.291662 495.272319,244.566223 495.852679,243.966518 C496.433039,243.366812 497.148805,243.066964 498,243.066964 L498.464286,243.066964 C498.15476,243.453871 498,243.860117 498,244.285714 C498,244.479168 498.019345,244.633928 498.058036,244.75 L501.017857,241.848214 C500.127972,241.190473 499.122029,240.861607 498,240.861607 Z" id="Combined-Shape"></path>
                      </g>
                    </g>
                  </svg>
                  <svg v-else width="26px" height="15px" viewBox="0 0 26 15" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                    <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                      <path d="M13,0 C17.2559737,0 21.5892637,2.51950605 26,7.55859375 L24.41369,9.14713598 C24.233135,9.32508678 24.0944945,9.45963496 23.9977679,9.55078125 L23.4184194,10.0655102 C23.0469651,10.3864185 22.5339814,10.8203098 21.8794643,11.3671875 C20.7574349,12.3046922 19.8482178,12.949217 19.1517857,13.3007812 C18.4553537,13.6523455 17.536464,14.0234355 16.3950893,14.4140625 C15.2537145,14.8046895 14.1220294,15 13,15 C11.6071359,15 10.3303629,14.8242205 9.16964286,14.4726562 C8.00892277,14.121092 6.84822009,13.5156293 5.6875,12.65625 L4.86411632,12.0355211 C4.21725988,11.5380846 3.66864414,11.0902417 3.21826242,10.6919868 L2.95982143,10.4589844 C2.30208004,9.8535126 1.31548277,8.86719434 0,7.5 C2.51489353,4.9609248 4.74924618,3.07617803 6.703125,1.84570312 C8.65700382,0.615228223 10.7559412,0 13,0 Z M9.44444444,11.3681319 C10.4444494,12.4560494 11.6296228,13 13,13 C14.3703772,13 15.5462914,12.4560494 16.5277778,11.3681319 C17.5092642,10.2802143 18,8.99084995 18,7.5 C18,6.00915005 17.5092642,4.71978566 16.5277778,3.63186813 C15.5462914,2.5439506 14.3703772,2 13,2 C11.6296228,2 10.4537086,2.5439506 9.47222222,3.63186813 C8.49073583,4.71978566 8,6.00915005 8,7.5 C8,8.99084995 8.48147667,10.2802143 9.44444444,11.3681319 Z M13,6.18867925 C13,6.71698377 13.1730752,7.1509417 13.5192308,7.49056604 C13.8653863,7.83019038 14.3076896,8 14.8461538,8 C15.2307712,8 15.6153827,7.86792585 16,7.60377358 L16,8 C16,8.83019283 15.7115413,9.53773292 15.1346154,10.1226415 C14.5576894,10.7075501 13.8461581,11 13,11 C12.1538419,11 11.4423106,10.7075501 10.8653846,10.1226415 C10.2884587,9.53773292 10,8.83019283 10,8 C10,7.16980717 10.2884587,6.46226708 10.8653846,5.87735849 C11.4423106,5.29244991 12.1538419,5 13,5 L13.4615385,5 C13.1538446,5.37736038 13,5.77358283 13,6.18867925 Z" id="" fill="#ABABAB" fill-rule="nonzero"></path>
                    </g>
                  </svg>
                </i>
              </validation-provider>
            </div>

            <button class="submit w100 block no-outline pointer"
                    :class="{'submit-active': !invalid}"
                    :disabled="invalid">{{ btnText }}</button>

            <span v-if="isPassField"
                  class="notification main-green pointer"
                  @click="forgotPass">ai uitat parola?</span>

            <span v-else
                  class="notification main-green pointer"
                  @click="isPassField = true">login</span>

            <p class="invalid-credentials"
               v-if="loginErr">{{ errMsg }}</p>
          </div>

        </form>

      </ValidationObserver>

    </div>

  </section>
</template>

<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { mapState } from 'vuex'

export default {
  name: 'login',
  data () {
    return {
      password: '',
      email: '',
      passView: false,
      isPassField: true,
      isResetPass: this.$router.currentRoute.query.reset_pass,
      new_pass: undefined,
      confirm: undefined
    }
  },
  computed: {
    ...mapState({
      loginErr: state => state.login.loginErr,
      noEmail: state => state.login.noEmail,
      resetEmailSent: state => state.login.resetEmailSent
    }),
    btnText () {
      return this.isPassField ? 'login' : 'reset'
    },
    errMsg () {
      return this.noEmail ? 'email inexistent.' : 'emailul sau parola este incorectă.'
    }
  },
  methods: {
    backToLogin (ev) {
      ev.preventDefault()
      this.$store.commit('SET_MODULE_KEY_VALUE', {
        module: 'login',
        key: 'resetEmailSent',
        value: false
      })
      this.isPassField = true
    },
    submit () {
      this.isPassField
        ? this.$store.dispatch('login_user', { username: this.email, password: this.password })
        : this.$store.dispatch('forgot_pass', this.email)
    },
    submitNewPass () {
      this.$store.dispatch('save_new_pass', {
        newPass: this.new_pass,
        uuid: this.isResetPass,
        email: this.$router.currentRoute.query.email,
        clbk: () => {
          this.isResetPass = false
        }
      })
    },
    forgotPass () {
      /* ascunde campul de password */
      this.isPassField = false
      this.$store.commit('RESET_LOGIN_ERR')
    }
  },
  components: {
    ValidationProvider,
    ValidationObserver
  }
}
</script>

<style lang="less">
  @import "../assets/styles/var";
  .login-page {
    & > div {
      width: 360px;
      margin: 0 auto;
      padding-top: 160px;
    }
    .logo {
      width: 223px;
    }

    form {
      margin-top: 24px;
      padding: 70px 32px 48px;
      box-shadow: 0 0 12px 4px rgba(0, 0, 0, 0.1);
      border-radius: 12px;
      h1 {
        padding-bottom: 20px;
        font-size: 2.8rem;
      }
      div {
        position: relative;
        label {
          position: absolute;
          left: 6px;
          bottom: 6px;
        }
        img {
          width: 12px;
        }
      }
      input {
        width: 100%;
        padding-bottom: 3px;
        border: 1px solid lightgray;
        outline: none;
        background-color: white;
        text-align: center;
      }
      input,
      .submit {
        height: 35px;
        border-radius: 20px;
        font-size: 1.8rem;
      }
      #password + i {
        right: 10px;
        top: 10px;
        .eye-icon-view-pass {
          transform: translateY(-4px);
        }
      }
      .notification {
        padding-left: 12px;
        padding-bottom: 16px;
        display: inline-block;
        font-size: 1.6rem;
      }
      .error {
        position: absolute;
        left: 0;
        bottom: -14px;
        color: @red;
        font-size: 1rem;
      }
      .submit {
        margin-top: 22px;
        margin-bottom: 12px;
        border: none;
        background-color: lightgray;
        color: white;
        padding: 6px 0;
      }
      .submit-active {
        background-color: @main-green;
        transition: background-color .2s ease-in-out;
        &:hover {
          background-color: darken(@main-green, 20%, relative);
        }
      }
      .invalid-credentials {
        font-size: 1.6rem;
        text-align: center;
        color: @red;
      }
    }

    .reset-pass-text {
      font-size: 1.6rem;
      text-align: center;
      color: @main-green;

      button {
        display: block;
        border-radius: 4px;
        background-color: @main-green;
        color: white!important;
        font-weight: bold;
        padding: 4px 16px;
        width: 140px;
        margin: 12px auto 0;
        transition: background-color 0.2s ease-in-out;
        border: none;
        cursor: pointer;
        font-size: 1.6rem;
        &:hover {
          background-color: darken(@main-green, 20%, relative);
        }
      }
    }
  }
</style>
